import script from "./SubmissionDetailCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SubmissionDetailCard.vue?vue&type=script&setup=true&lang=js"

import "./SubmissionDetailCard.vue?vue&type=style&index=0&id=5d4ef5a6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d4ef5a6"]])

export default __exports__